import { IDispositionData } from 'views/ProFormaTable/types';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { SelectedType, StabilizedKey } from './types';

interface ColumnHeaderText {
    title: string;
    subtitlePrefix?: string;
    subtitle: string;
}

export const getStabilizationColumnHeaderText = (
    key: StabilizedKey,
    disposition?: IDispositionData,
    showCents?: boolean,
    selectedType?: SelectedType,
): ColumnHeaderText => {
    const defaultValue = numeralFormatterCurrency(0, showCents ? '$0,0.00' : '$0,0');
    const defaultSubtitleValue = numeralFormatterCurrency(0, '$0,0.00');

    const perValueMap: any = {
        unit: disposition?.stabilizedValuePerUnit,
        sf: disposition?.stabilizedValuePerSf,
        GSF: disposition?.stabilizedValuePerGrossSf,
        RSF: disposition?.stabilizedValuePerSf,
    };
    const stabilized = disposition?.stabilizedValue;
    const perValue = perValueMap[selectedType as SelectedType];

    const subtitlePrefix = `$ / ${selectedType}: `;

    if (
        !stabilized
    || !stabilized[key]
    || !perValue
    || !perValue[key]
    ) {
        return {
            title: defaultValue,
            subtitlePrefix,
            subtitle: defaultSubtitleValue,
        };
    }

    return {
        title: numeralFormatterCurrency(stabilized[key] ?? 0, showCents ? '$0,0.00' : '$0,0'),
        subtitlePrefix,
        subtitle: numeralFormatterCurrency(perValue[key] ?? 0, '$0,0.00'),
    };
};
